import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { FETCH_LIGHTSPEED_LOCATIONS } from './queries'
import { LightspeedBusiness } from '../Manage/ManageLightspeed/types'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import { useIntegration } from '../hooks/useIntegration'
import { PartnerName, PARTNER_SLUGS, isPartner } from '../constants'
import { LoaderProps } from 'router/Loaders/types'

export const LightspeedBusinessesLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const navigate = useNavigate()
  const { addMessage } = useMessageStore()
  const { integrations } = useMerchant()
  const {
    lightspeedBusinesses,
    setLightspeedBusinesses,
    setLightspeedAuthExpired
  } = useIntegration()

  const hasIntegrationConnected = integrations?.some(
    (partner: { partner: { name: string } }) =>
      isPartner(partner.partner.name, PartnerName.LIGHTSPEED)
  )

  const [isLoaded, setIsLoaded] = useState(false)

  const { data, loading } = useQuery<{
    fetchLightspeedIds: LightspeedBusiness[]
  }>(FETCH_LIGHTSPEED_LOCATIONS, {
    skip: !hasIntegrationConnected || lightspeedBusinesses.length > 0,
    onError: () => {
      if (!hasIntegrationConnected) {
        return
      }

      setLightspeedAuthExpired(true)

      addMessage({
        type: 'message',
        content: 'Your session has expired. Please log in again.'
      })
      navigate(`/integrations/${PARTNER_SLUGS.LIGHTSPEED}`)
    }
  })

  useEffect(() => {
    if (data?.fetchLightspeedIds) {
      setLightspeedBusinesses(data.fetchLightspeedIds)
      setLightspeedAuthExpired(false)
    }
  }, [data])

  useEffect(() => {
    setIsLoaded(isParentLoaded && (!hasIntegrationConnected || !loading))
  }, [loading, isParentLoaded, hasIntegrationConnected])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
